import React, { useState } from 'react';

import { EVENT } from '../../../globals';

import axios from 'axios';

import { useApp } from '../../_libs/hooks/useApp';
import { useBrand } from '../../_libs/hooks/useBrand';

import PdfUrlContext from './context';
import { PdfUrlValue } from './types';
import uploadPdfBlobWithFileNameAndOpts from '../../_libs/utils/uploadPdfBlobWithFileNameAndOpts';

const PdfUrlProvider = (props): JSX.Element => {
  const [pdfUrl, setPdfUrl] = useState<string>(null);
  const [pdfBlob, setPdfBlob] = useState<Blob>(null);
  
  const { reportData: appReportData, userId } = useApp();
  const { primaryBrand, coBrand } = useBrand();

  async function _setPdfBlob(data: any, fileName: string) {
    const report_url = await uploadPdfBlobWithFileNameAndOpts(
      data.blob,
      encodeURIComponent(fileName),
      {
        folderPath: '/reports/',
      },
    );
    if (report_url) {
      setPdfUrl(report_url);
      axios
        .post('/update_report/', {
          reportId: appReportData.id,
          organizationId: primaryBrand.id,
          coBrandId: coBrand.id,
          userId,
          eventCode: EVENT.UpdateReport,
          key: 'report_url',
          value: report_url,
        });
    } else {
      setPdfUrl(null);
      console.error('Could not upload PDF.');
    }
    setPdfBlob(data.blob);
    document.getElementById('js-pdf-container').style.display = 'block';
  }

  const value: PdfUrlValue = {
    pdfBlob,
    pdfUrl,
    setPdfUrl,
    setPdfBlob: _setPdfBlob,
  };
  return <PdfUrlContext.Provider value={value} {...props} />;
};

export default PdfUrlProvider;
